import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.1875 6.6875H8.3125V1.8125C8.3125 1.325 7.9875 1 7.5 1C7.0125 1 6.6875 1.325 6.6875 1.8125V6.6875H1.8125C1.325 6.6875 1 7.0125 1 7.5C1 7.9875 1.325 8.3125 1.8125 8.3125H6.6875V13.1875C6.6875 13.675 7.0125 14 7.5 14C7.9875 14 8.3125 13.675 8.3125 13.1875V8.3125H13.1875C13.675 8.3125 14 7.9875 14 7.5C14 7.0125 13.675 6.6875 13.1875 6.6875Z",
		fill: "currentColor"
	})
});
export default SvgIconAdd;
